import type { FormStatus } from './formTypes'

export enum PositionOpenStatus {
  Open = 'open',
  Closed = 'closed',
  OnHold = 'on_hold',
  Archived = 'archived',
}

export enum PositionResult {
  Filled = 'filled',
  Unfilled = 'unfilled',
}

export enum PositionType {
  FullTime = 'full_time',
  PartTime = 'part_time',
  Internship = 'internship',
  Contract = 'contract',
  Freelance = 'freelance',
  Other = 'other',
}

export interface Position {
  completedAt?: string
  id: string
  orgId: string
  positionName: string
  positionType: PositionType
  positionData: {
    [key: string]: any
  }
  status: FormStatus
  openStatus: PositionOpenStatus
  result?: PositionResult
  createdBy?: string
  createdByName?: string
  createdAt: string
  updatedAt: string
  isExample?: boolean
}

export interface CreatePositionRequest {
  orgId: string
  positionName: string
  positionType: PositionType
  positionData?: {
    [key: string]: any
  }
}

export type UpdatePositionRequest = Partial<Position> & Pick<Position, 'id'>

export interface JobDescriptionResponse {
  jobDescription: string
}

export interface SaveJobDescriptionRequest {
  jobDescription: string
}
